/**
 * EAkte Plus API
 * API eakteplus document metadata api
 *
 * OpenAPI spec version: 1.0.0
 * Contact: ehgidencores@eulerhermes.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type MetadataDefinitionEnum = 'DOCUMENT_CATEGORY' | 'DOCUMENT_TYPE' | 'DOCUMENT_STATUS' | 'DOCUMENT_PROCESSED' | 'CONFIDENTIALITY_LEVEL' | 'DATA_PROTECTION' | 'COUNTRY' | 'IN_OUT_FLAG' | 'DOCUMENT_CHANNEL' | 'DELIVERY_SYSTEM';

export const MetadataDefinitionEnum = {
	DOCUMENTCATEGORY: 'DOCUMENT_CATEGORY' as MetadataDefinitionEnum,
	DOCUMENTTYPE: 'DOCUMENT_TYPE' as MetadataDefinitionEnum,
	DOCUMENTSTATUS: 'DOCUMENT_STATUS' as MetadataDefinitionEnum,
	DOCUMENTPROCESSED: 'DOCUMENT_PROCESSED' as MetadataDefinitionEnum,
	CONFIDENTIALITYLEVEL: 'CONFIDENTIALITY_LEVEL' as MetadataDefinitionEnum,
	DATAPROTECTION: 'DATA_PROTECTION' as MetadataDefinitionEnum,
	COUNTRY: 'COUNTRY' as MetadataDefinitionEnum,
	INOUTFLAG: 'IN_OUT_FLAG' as MetadataDefinitionEnum,
	DOCUMENTCHANNEL: 'DOCUMENT_CHANNEL' as MetadataDefinitionEnum,
	DELIVERYSYSTEM: 'DELIVERY_SYSTEM' as MetadataDefinitionEnum
};